<template>
    <b-container fluid class="top-padding bottom-padding" style='font-size: 1.1rem'>
<img style='width: 100%;' class='rounded-image' :src='this.getSiteImageUrl("iStock-000015582770-hw-site-banner-thin-2.jpg")' />        

    <div class='centered'>
        <div class='centered inline-auto-width'>
            <h3>Expand your talent...</h3>
            <h3>Ignite your creative outlet...</h3>
            <h3>And unlock access to thousands of mind-expanding designs</h3>
            <h3>to inspire your next creation</h3>
        </div>
    </div>

<div style='padding-top: 0rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>

    <div class='centered'>
        <div class='padded-square-box promo-box-color' style='width: 70%'>
            <h2>Handweaving.net</h2>
            <h1>
            “The gold standard resource for all weavers today.”
            </h1>
            <br/>
            <h2>Your exclusive invitation</h2>
        </div>
    </div>

<div style='padding-top: 1.5rem;' class='centered'>
    <img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>

    <div class='bold top-padding'>
        <h4 class='bold'>Note: the following invitation expires on February 16, 2021</h4>
    </div>

<div class='background-two clear-float-fix'>
    
    <img class='embed-right' :src='this.getSiteImageUrl("iStock-904173008-500.jpg")' /> 

    Dear Weaver, 
    <br/><br/>
    My name is Kris Bruland, and I’m the owner of Handweaving.net.
    <br/><br/>
    Let me just start by saying this invitation has been over 300 years in the making. 
    <br/><br/>
    That’s because access to this modern-age museum of weaving resources is unlike anything you’ve experienced, with beautiful drafts and documents spanning many centuries of weaving history.
    <br/><br/>
    To be clear, this special invite is not extended to everyone, just exclusively to committed weavers of Tien Chiu's Warp &amp; Weave community. 
</div>

<div class='background-one centered' style='padding-top: 1.0rem'>

    <div>
    You, my friend, are invited to pull up your loom and join me inside...
    </div>

    <h1>The Handweaving.net Weavers Wonderland</h1>

    <div> 
        The world-renowned digital weaving information center<br/>
        That holds <span class='underline'>every</span> design resource for <span class='underline'>every</span> level of weaver.
    </div>
</div>


    <div class='centered top-padding bottom-padding'>
        <div class='padded-box quotation'>
            <div class='centered quotation'>“You are doing a marvelous job of bringing so many wonderful resources to the weaving community world wide. ” <span class='normal-text'>-Dawn&nbsp;T.</span></div>
        </div>
    </div>


<div class='background-two' style='margin-top: 1.0rem'>
    <div class='centered'>
    <h2>Become a more knowledgeable, motivated, and capable weaver when you...</h2>
    </div>
    <div class='clear-float-fix'>

        <img class='embed-right' :src='this.getSiteImageUrl("iStock-1163727517-500.jpg")' /> 

        <ul>
            <li>Tap into nearly 75,000 digital historic weaving drafts available for searching, viewing, printing, downloading, and coloring instantly online.</li>

            <li>Get immediate access to many beautiful drafts not available anywhere else and expand your horizons for new creative projects.</li>

            <li>Discover the easy-to-use software that applies <span class='italic'>your</span> colors to both online and personal drafts so that you can visually see what’s possible with the exact colors to make it happen.</li>

            <li>Design your own drafts by soaking up new ideas, then adding your own creativity with different colors and fibers!</li>

            <li>Uncover access to brand new (to you) collections from hundreds of years of weaving, so you always have the perfect starting point and a beacon for every project.</li>

            <li>Save yourself COUNTLESS hours and unnecessary mistakes with ready-to-use proven drafts for your next and best project.</li>
        </ul>
        <div class='bold centered'>
            No matter how many shafts you have and<br/>
            no matter what type of design you’re looking to weave...<br/>just add your preferences and immediately see
            every possible draft!
        </div>
    </div>
</div>

<div class='background-one'>

<div class='bold centered'><h2>When you join the Handweaving.net Weavers Wonderland, you’ll gain immediate access to:</h2></div>

<h2 class='top-padding bold'>1. The Draft Collections </h2>


<div>

<img class='embed-left' :src='this.getSiteImageUrl("63611-4-tr.png")' /> 

Maybe you have a weave structure in mind, or maybe you have nothing particular in mind...<br/><br/>
Your looms could range from 8-12 shafts, or maybe you’re getting started on a 4-shaft, or maybe you have 40... <br/><br/>
However things look for you on any given day, the site’s search capabilities allow you to easily narrow your focus to drafts particularly relevant to your needs.

<br/><br/>

No more hunting down every weaving book possible, searching content, and sifting through options that you’re not sure are even worth your while. 
Instead, our search function provides you with only the info you need (and nothing that you don’t).  Plus our “Same Threading” search can show you all of the different drafts that can be woven on the same warp without rethreading!

<br/><br/>

With more than 70 weaving draft collections and access to nearly 75,000 digital weaving drafts produced from historical and modern sources - you have a much-needed new option to discover and weave beautiful projects! 
</div>

<div class='centered'>
    
</div>
<div class='centered top-padding' style='clear: both; padding-bottom: 2rem'>
    <div class='padded-box quotation'>
        <div class='centered quotation'>“I spend hours perusing the vast weaving drafts you have collected!! It’s so helpful - thank you!” <span class='normal-text'>-Susan&nbsp;K.</span> </div>
    </div>
</div>

<h2 class='top-padding bold'>2. The Draft Color Editor</h2>
<div>
<img class='embed-left' :src='this.getSiteImageUrl("color-editor-sample-small.png")' />

This powerful tool allows you to replicate a specific color palette from any of your own photos. 
You can simply upload ANY photo from any device to pinpoint and visualize exactly what you have
 in mind for colors within the fabric drawdown, plus you can choose colors by hand too.
<br/><br/>
A new addition to our 2020 upgrades, this drafting color tool is an exciting experience while still straightforward to use. You can instantly try custom colors on both your own drafts and those from the site, allowing your creativity to take flight! 
</div>
<div style='clear: both; padding-bottom: 2rem' class='centered top-padding'>
    <div>
    </div>
    <div class='padded-box quotation'>
        <div class='centered quotation'>“I love the draft color editor. It has been so much fun to design with this capability!” <span class='normal-text'>-Peggy&nbsp;R.</span> </div>
    </div>
</div>

<h2 class='top-padding bold'>3. The Documents Library</h2>

<div>

<img class='embed-left' :src='this.getSiteImageUrl("Swift.png")' />


Lose yourself in more than 8,000 searchable historic documents on weaving, textiles, lace, and related topics available for viewing and download. Much of this info was compiled by Ralph Griswold and was only available through a Tucson, AZ university collection. With Ralph’s blessing and encouragement, we offer all of these proprietary documents to make this collection continually and freely available for all those in our weaving community. 

</div>

<div class='centered' style='clear: both'>
</div>

    <div class='centered top-padding bottom-padding'>
        <div class='padded-box quotation'>
            <div class='centered quotation'>“I regularly repair and rehab old looms, so when I'm researching early weaving 
                technology, the Handweaving.net documents are often my only available source, as many of 
                these publications are out of print or simply unavailable! I'm always amazed 
                that I have these historical documents at my fingertips.”  <span class='normal-text'>-Liz&nbsp;M.</span> </div>
        </div>
    </div>

</div>

<div class='background-two clear-float-fix' style='margin-bottom: 2rem'>
    <div class='centered'>
        <h2 class='bold'>This membership is for you if...</h2>
    </div>

    <img class='embed-right' :src='this.getSiteImageUrl("iStock-1198398707-500.jpg")' /> 
    
    <ul>
        <li>You are a weaver or want to become one...every weaver needs to be here!</li>
        <li>You want to be inspired by thousands of gorgeous drafts created across many centuries</li>
        <li>You need to stay focused and inspired yet without compromising creativity</li>
        <li>You create your own drafts or want to learn how, with examples from others along the way</li>
    </ul>
</div>

<div style='padding-top: 1.0rem; padding-bottom: 2.0rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>


<div class='padded-square-box promo-box-color centered' style='padding-top: 1.5rem; padding-bottom: 1.0rem; margin-bottom: 2.0rem'>
    <h2 class='bold'>Your Exclusive Invite</h2>

    Our endless time-saving drafts and inspirational resources have been meticulously 
    compiled for you, the knowledgeable and inspiration-hungry weaver. 
    While the information is invaluable and often unavailable anywhere else, 
    we’re committed to making it accessible for you! 
    <br/><br/>
    Yearly Subscription <span class='strike-through'>$25.00</span>
    <br/><br/>
    <span class='bold'>But when you join today as a new subscriber we’re adding on an extra discount of THREE FREE MONTHS!</span>
    <br/><br/>
    That means for your first full year of access, <span class='italic bold'>you’ll only pay $18.75!&nbsp;&nbsp;</span>
    <br/><br/>
    <b-button variant='primary' @click='navigateToSubscription'>I Want In! &raquo;</b-button>
</div>

<div style='padding-top: 0.3rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>


<div class='background-one clear-float-fix' style='margin-bottom: 2.0rem'>
    <div class='centered' style='padding:0; margin:0; padding-bottom: 1.0rem'>
        <h2 class='bold'>Let me answer the most common questions you might have…</h2>
    </div>


<img class='embed-right' :src='this.getSiteImageUrl("iStock-852949362-500.jpg")' />


<span class='bold'>1.	What does your membership include? </span>
    <br/><br/>
    Your annual subscription provides one year of unlimited access to all of Handweaving.net!  You can search, view, download, organize, save, and color any of our nearly 75,000 drafts, as well as using the Color Editor and other sections of the site.
    <br/><br/>
    <span class='bold'>
    2.	But there’s so much information - how do I know I’ll be able to find what I need?
    </span>
    <br/><br/>
    
    We have worked very hard to make our drafts and documents easy to search in a number of ways, and you always have the option to only see those your loom could weave, plus we are continually improving the sites search capabilities.

    <br/><br/>

    <img style='clear:both' class='embed-right' :src='this.getSiteImageUrl("iStock-1246464399-500.jpg")' />
    <span class='bold'>
    3.	Will the information be too advanced for me?
    </span>
    <br/><br/>
    
    All levels of weavers use and love Handweaving.net, from complete beginners through the most advanced in the world, we have amazing things for YOU!
    <br/><br/>

    
    <span class='bold'>
    4.	What if I ever need to cancel? 
    </span>
    <br/><br/>
    
    Cancelling is very easy and you can unsubscribe with a single click at any time if you need to.
    <br/><br/>

    <img style='clear: both' class='embed-right' :src='this.getSiteImageUrl("iStock-915429748-500.jpg")' />
    <span class='bold'>
    5.	Making purchases online concerns me, how do I know this is safe?
    </span>
    <br/><br/>
    
    Safety of your information is a top priority for us, and after careful research we use a very secure online payments provider, Braintree Payments, which is owned and operated by PayPal.  Even we don't have access to your payment information which is kept only by them in a secure and safe digital vault, and never on Handweaving.net itself.
    <br/><br/>


    
    <span class='bold'>
    6.	How many drafts can I access and download? 
    </span>
    <br/><br/>
    
    While your annual subscription is active, you can access an unlimited number of drafts, there are no limits on the number you can access online, save for later, or download!
    <br/><br/>

    <span class='bold'>
    7.	When does this amazing offer end? 
    </span>
    <br/><br/>
    
    This exclusive offer for the Warp &amp; Weave commununity ends on February 16, 2021.
    <br/><br/>
</div>

<div class='background-two'>
<div class='centered'>
<h2 class='bold'>So who’s the face behind all of this?</h2>
</div>

    <img style='float: left; border-radius: 50%; vertical-align: top; max-width: 200px; padding-right: 1rem' :src='this.getSiteImageUrl("kb-bw.jpg")' />
    Hey! I’m Kris - an avid woodworker, software architect <span class='italic'>(building software is like solving a puzzle for me!)</span>, and enthusiast for anything creative and beautiful. And with a passion for both weaving and preserving its history - I’m honored that you’ve found your way here today to Handweaving.net. 
    <br/><br/>
    <span class='italic'>If we were in person, I’d brew you up some of my home-roasted coffee or pour you a glass of my hard cider from the apples in our orchard on Whidbey Island - both are always crowd-pleasers!</span>
    <br/><br/>
    And while I know there aren’t swarms of people who find excitement in discovering new handwoven cloth <span class='italic'>(my kids, for instance)</span> - I know that you’re one of the unique few who do. 
    <br/><br/>
    And that’s exactly why I’m so committed and driven to make sure even the most inaccessible and unknown weaving patterns are now at your fingertips. Thank you for being here, I can’t wait to see what you create! 
</div>

<div style='padding-top: 1.5rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>

<div class='background-one thick-border-box promo-box-color centered' style='margin-top: 1rem; margin-bottom: 1rem;'>

    Unlimited access is all yours for yearly subscription membership of only <span class='strike-through'>$25.00</span>
    <br/><br/>
    <span class='bold'>
        But when you join today-<br/> we’re adding on an extra discount of THREE FREE MONTHS... <br/>
        Pay just $18.75 for your first year! &nbsp;&nbsp;
        <br/><br/>
    </span>
    <b-button variant='primary' @click='navigateToSubscription'>I Want In! &raquo;</b-button>
    <br/><br/>
    <span class='bold'>THIS INVITE IS ONLY AVAILABLE UNTIL February 16, 2021.</span>
    <br/><br/>
    <span class='bold'>Receive your first three months FREE as a new member when you join today</span>
</div>

<div style='padding-top: 0.3rem; padding-bottom: 1.5rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>

<div style='padding-top: 2rem; padding-bottom: 2rem;' class='background-two centered'>

    <h2 class='bold' style='padding-bottom: 0.7rem'>Instead of wasting time searching for that ONE. RIGHT. DRAFT...</h2>

    <h4>Know that we’ve already got it for you!</h4>

    <h4>Simply and quickly within the click of <span class='italic'>One. Single. Button.</span></h4>

</div>

<div class='background-one clear-float-fix' style='margin-bottom: 2.0rem'>
    <div class='centered'>
        <h2 class='bold'>
            Here’s why this resource is like nothing you’ve ever experienced online!
        </h2>
    </div>

    <img class='embed-right' :src='this.getSiteImageUrl("iStock-1065362580-500.jpg")' />
    You know how I hinted at being a bit of a computer nerd? Well, here’s where you benefit from that big-time... 
    <br/><br/>
    My professional experience includes contracting to a handful of Fortune 500 companies like Amazon, Microsoft, and other big-name firms, I’ve spent my software architect career building world-class online systems.
    <br/><br/>
    And that’s exactly what I’ve done inside Handweaving.net for you!
    <br/><br/>
    
    I’ve taken all my experience and knowledge in the computer science field, and used it to create for you a profoundly advanced yet simple-to-use system. 
    <br/><br/>
    
    
    No more wasting time thinking up designs, trying to find the right patterns, or starting a draft only to hit a roadblock!
    <br/><br/>
    I’ve done the leg-work of starting with countless scanned books, interpreting and producing digital modern drafts from them with my own specialized software, fixing draft errors, and decoding countless designs and translations… all so they are readily available for you within seconds.
</div>

<div style='padding-top: 0rem; padding-bottom: 2rem' class='centered'>
    <img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>
    <div class='promo-box-color centered top-padding bottom-padding'>
        <h3>
            From my studio to yours - enjoy an unparalleled resource 
            that has become the modern-day benchmark for thousands of other weavers worldwide. 
            That’s my promise to you.
        </h3>
        
        Subscribe today and enjoy an additional THREE FREE MONTHS!
        <br/><br/>
            Today’s Price: <span class='bold'>$18.75</span>
        <br/><br/>
        <b-button variant='primary' @click='navigateToSubscription'>I Want In! &raquo;</b-button>
    </div>
    <div style='padding-top: 2rem' class='centered'><img style='max-width: 30%' :src='this.getSiteImageUrl("fancy-divider.png")' /></div>
    <div class='centered'>
        <img style='max-width: 80%' :src='this.getSiteImageUrl("iStock-1026415188-500.jpg")' />
    </div>
    </b-container>
</template>

<script>

import mediaService from '../mixins/mediaService.js'

export default {
    mixins: [mediaService],
    data: function() {
        return {
            bgStyleObj:
            {
                'background-image': 'url(' + this.getBGImageUrl() + ')',
                'background-size': '100% 100%'
            }
        }
    },
    components: {
    },
    methods: {
        navigateToSubscription() {
            this.$router.push({ name: 'Subscription' })
        },
        getBGImageUrl() {
            return this.getSiteImageUrl('iStock-000015582770-hw-site-banner.jpg')
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Warp & Weave Community Promotion')
        this.$store.commit('setDiscountPlanID', 'warpweave-25')
        this.$store.commit('setDiscountPlanMessage', 'Regularly $25/year, Warp & Weave community special for new subscribers - THREE FREE MONTHS your first year - just $18.75 your first year!')
        this.$store.commit('setShowHeaderFooter', false)
    },
    beforeDestroy() {
        this.$store.commit('setShowHeaderFooter', true)
    }
}
</script>

<style scoped>
.maxLogoHeight {
    max-height: 90px;
    height: 90px;
}
li {
    padding: 0.25rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
div {
    padding-top: 1.0rem;
    padding-bottom: 1.0rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 0.5rem;
}
img.rounded {
  object-fit: cover;
  border-radius: 50%;
}

.rounded {
    border-radius: 50%
}

.background-two {
    background-color: #ffffff;
}

.background-two {
  background-color: #f9f8f3;
}

.padded-box {
    border: solid 1px black;
    border-radius: 0.5rem;
    padding: 0.2rem;
    width: 80%;
    text-align: center;
    display: inline-block;
}

.padded-square-box {
    border: solid 1px black;
    padding: 0.2rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    text-align: center;
    display: inline-block;
}

.quotation {
    font-style: italic;
    background-color: #fef5dc;
}
.thick-border-box {
    border-color: #000000;
    border: solid 1px;
    border-radius: 0.5rem;
}
.promo-box-color {
    background-color: #fef5dc;
}
.indented {
    padding-left: 3rem;
    margin-top: 0;
    margin-bottom:0;
    padding-top: 0;
    padding-bottom:0;
}

.rounded-image {
    border-radius: 0.5rem;
}

.header-container {
    color: black;
}

.transparent {
    background-color: rgba(255, 255, 255, 0.96);
}

.embed-left {
    float: left; 
    max-width: 33%; 
    vertical-align: top; 
    padding-right: 1.5rem; 
    padding-bottom: 0.5rem;
    border-radius: 0.5rem;
}

.embed-right {
    float: right; 
    max-width: 33%; 
    margin: 1.0rem;
    border-radius: 0.5rem;
}

.clear-float-fix {
    overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/WarpWeavePromo.vue